import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  MatToolbarModule,
  MatIconModule,
  MatSidenavModule,
  MatListModule,
  MatButtonModule
} from "@angular/material";

import { MatExpansionModule } from "@angular/material/expansion";
import {
  AlertService,
  MissionService,
  ThingsSyncService,
  HTTPCallsService,
  DataStore
} from "./_services";
import { routing } from "./app-routing.module";
import { JwtInterceptor } from "./_helpers";
import { AppComponent } from "./app.component";
import { BsDropdownModule } from "ngx-bootstrap";
import { Ng2TelInputModule } from "ng2-tel-input";
import { LoginComponent } from "./login";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { LayoutModule } from "@angular/cdk/layout";
import { AlertComponent } from "./_components";
import { ErrorInterceptor } from "./_helpers";
import { UiSwitchModule } from "ngx-ui-switch";
import { AccessComponent } from "./dashboard/access/access.component";
import { ThingsComponent } from "./dashboard/things/things.component";
import { SettingsComponent } from "./dashboard/settings/settings.component";
import { ThingSettingsComponent } from "./dashboard/things/thing-settings/thing-settings.component";
import { ReplacePipe } from "./_helpers/replace.pipe";
import { MatSliderModule } from "@angular/material/slider";
import { ThingSettingsEditComponent } from "./dashboard/things/thing-settings/thing-settings-edit/thing-settings-edit.component";
import { dbrouting } from "./_services/dataStore.service";
import { MsaterControlComponent } from './dashboard/things/msater-control/msater-control.component';
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDialogModule } from "@angular/material/dialog";
import { AddNumberDialogComponent } from './dashboard/things/thing-settings/thing-settings-edit/add-number-dialog/add-number-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    routing,
    BsDropdownModule.forRoot(),
    Ng2TelInputModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatSliderModule,
    BrowserAnimationsModule,
    LayoutModule,
    UiSwitchModule,
    MatExpansionModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    dbrouting
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    AlertComponent,
    AccessComponent,
    ThingsComponent,
    SettingsComponent,
    ThingSettingsComponent,
    ReplacePipe,
    ThingSettingsEditComponent,
    MsaterControlComponent,
    AddNumberDialogComponent
  ],
  providers: [
    AlertService,
    MissionService,
    ThingsSyncService,
    HTTPCallsService,
    DataStore,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  entryComponents: [MsaterControlComponent, AddNumberDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
